module.exports = __webpack_public_path__ + "static/Disinfection-service-whocanuseit-ee6eb6f8e2859b42e06deb2f5b296113.png";